import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  mutationEditorClear,
  mutationEditorQuestionsMove,
} from 'gql/mutations/editor';
import {
  useMutationQuestionDuplicateMultiple,
  useMutationQuestionDeleteMultiple,
} from 'gql/mutations/question';
import { useQueryLocalEditor } from 'gql/queries/local';
import { trackEvent, reportError } from 'lib/tracking';

import Multi from './Multi';

const MultiContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const {
    data: {
      editor: { questionsSelected },
    },
  } = useQueryLocalEditor();
  const mutationQuestionDeleteMultiple = useMutationQuestionDeleteMultiple();
  const handleQuestionsDelete = useCallback(async () => {
    try {
      await mutationQuestionDeleteMultiple(course, questionsSelected);
      mutationEditorClear();
      trackEvent('question', 'delete');
    } catch (err) {
      reportError('question', 'delete', err);
    }
  }, [course, mutationQuestionDeleteMultiple, questionsSelected]);
  const mutationQuestionDuplicateMultiple =
    useMutationQuestionDuplicateMultiple();
  const handleQuestionsDuplicate = useCallback(async () => {
    try {
      await mutationQuestionDuplicateMultiple(course, questionsSelected);
      trackEvent('question', 'duplicate');
    } catch (err) {
      reportError('question', 'duplicate', err);
    }
  }, [course, mutationQuestionDuplicateMultiple, questionsSelected]);
  return questionsSelected.length >= 1 ? (
    <Multi
      handleClear={mutationEditorClear}
      handleQuestionsDelete={handleQuestionsDelete}
      handleQuestionsDuplicate={handleQuestionsDuplicate}
      handleQuestionsMove={mutationEditorQuestionsMove}
      t={t}
      {...props}
    />
  ) : null;
};

MultiContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default MultiContainer;
